export function passwordTheme(theme) {
  return {
    getCSS: ({ targetElement, isValid, disabled }) => {
      switch (targetElement) {
        case 'container': {
          return {
            position: 'relative',
          };
        }

        case 'toggle': {
          const iconColor = !disabled ? theme.colors.black : theme.colors.neutrals.t400;

          return {
            position: 'absolute',
            top: '50%',
            right: theme.space[2],
            transform: 'translateY(-50%)',
            background: 'white',
            border: 0,
            padding: '6px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': {
              fill: iconColor,
            },
          };
        }
        case 'rules': {
          return {
            display: 'grid',
            gridTemplateColumns: `repeat(2, minmax(${theme.space[15]}, max-content))`,
            listStyle: 'none',
            padding: `${theme.space[3]} 0 0 0`,
            margin: 0,
            rowGap: theme.space[3],
            columnGap: theme.space[5],
          };
        }

        case 'rule': {
          return {
            listStyle: 'none',
            display: 'flex',
            margin: 0,
            padding: 0,
            flexDirection: 'column',
            alignItems: 'flex-start',
            columnGap: theme.space[3],
          };
        }

        case 'check': {
          const backgroundColor = isValid ? theme.colors.green.t100 : theme.colors.secondary.lightBlue.t25;

          return {
            flex: `0 0 ${theme.space[6]}`,
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            width: theme.space[6],
            height: theme.space[6],
            borderRadius: theme.radii[4],
            backgroundColor,
          };
        }

        default: {
          return null;
        }
      }
    },
  };
}
